<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="add()"
      >添加</el-button>
      <span style="padding: 0 10px">角色名称</span>
      <el-input
        v-model="roleName"
        placeholder="请输入角色名称"
        style="width: 200px; height: 30px; line-height: 30px"
        clearable
        @keyup.enter.native="handleSelect"
      />
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="handleSelect"
      >筛选</el-button>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      style="width: 1111px"
      height="calc(100vh - 230px )"
      size="mini"
    >
      <el-table-column prop="roleSort" label="显示顺序" width="200" />
      <el-table-column prop="name" label="角色名称" width="150" />
      <el-table-column prop="roleKey" label="权限标识" width="200" />
      <el-table-column prop="remark" label="角色描述" width="180" />
      <el-table-column prop="createdAt" label="创建时间" width="200">
        <template slot-scope="scoped">
          {{
            $parseTime(
              new Date(scoped.row.createdAt),
              "{y}-{m}-{d} {h}:{i}:{s}"
            )
          }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            icon="el-icon-edit"
            @click="edit(scope.row)"
          >
            编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getRoleinfo"
    />

    <!-- 编辑弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="560px"
      :close-on-click-modal="false"
      :title="Isedit ? '编辑' : '添加'"
      @close="handleClose"
    >
      <div class="edit_titile">
        <el-form ref="form" :model="formData" label-width="80px">
          <el-form-item label="角色名称">
            <el-input v-model="formData.name" placeholder="请输入角色名称" />
          </el-form-item>
          <el-form-item label="权限标识">
            <el-input v-model="formData.roleKey" placeholder="请输入权限标识" />
          </el-form-item>
          <el-form-item label="显示顺序">
            <el-input
              v-model="formData.roleSort"
              placeholder="请输入显示顺序"
            />
          </el-form-item>
          <el-form-item label="角色描述">
            <el-input v-model="formData.remark" placeholder="请输入描述" />
          </el-form-item>
          <el-form-item v-if="Isedit" label="菜单权限">
            <el-tree
              ref="refMenu"
              :props="routerProps"
              :data="routerData"
              show-checkbox
              node-key="id"
              @check="handleCheckChange"
            />
          </el-form-item>

          <!-- 弹窗脚部 -->
          <el-form-item>
            <el-button @click="edit_dialogVisible = false">取 消</el-button>
            <el-popconfirm
              :title="'确定' + `${Isedit ? '修改' : '添加'}` + '吗？'"
              @onConfirm="submitForm()"
            >
              <el-button
                slot="reference"
                type="primary"
                class="edit-button"
                style="margin-left: 10px"
              >
                确定</el-button>
            </el-popconfirm>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination' // 引入分页器
import { getRoleRouter } from '@/api/menu.js'
import { addRole, updataRole, getRoleList } from '@/api/role.js'
import { addRoleMenu } from '@/api/roleMenu.js'
export default {
  name: 'RoleManagement',
  components: { Pagination },
  data() {
    return {
      roleName: '',
      showtabelData: [], // 展示的表单信息
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // loading
      routerProps: {
        label: 'label',
        children: 'children'
      },
      pageNum: 1,
      pageSize: 100,
      total: 0,
      routerData: [],
      formData: {},
      initRouter: []
    }
  },
  mounted() {
    this.getRoleinfo()
  },
  methods: {
    // 获取角色表单信息
    getRoleinfo() {
      var params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.roleName
      }
      this.loading = true
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      getRoleList(params)
        .then((res) => {
          this.showtabelData = res.rows
          this.total = res.count
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 关闭弹窗
    handleClose() {},
    // 搜索
    handleSelect() {
      this.getRoleinfo()
    },
    // 打开编辑弹窗
    edit(row) {
      console.log(row, 'row.....................')
      this.formData = {}
      this.getRouterList(row.web_role_menus)
      this.formData = JSON.parse(JSON.stringify(row))
      this.Isedit = true
      this.edit_dialogVisible = true
    },
    // 打开添加弹窗
    add() {
      this.formData = {}
      this.Isedit = false
      this.edit_dialogVisible = true
    },
    // 更新信息
    submitForm() {
      // 编辑
      if (this.Isedit) {
        updataRole(this.formData).then((res) => {
          this.$message.success('修改成功')
          this.edit_dialogVisible = false
          if (this.formData.menuId && this.formData.menuId.length > 0) {
            this.addRoleMenuEvent(this.formData.id)
          }
        })
      } else {
        addRole(this.formData).then((res) => {
          this.$message.success('添加成功')
          this.edit_dialogVisible = false
          this.getRoleinfo()
        })
      }
    },
    addRoleMenuEvent(roleId) {
      console.log(this.initRouter, 'this.initRouter')
      const roleMenuArr = []
      if (this.formData.menuId && this.formData.menuId.length > 0) {
        this.formData.menuId.map((item) => {
          roleMenuArr.push({
            menuId: item,
            roleId
          })
        })
      }
      const resources = []
      for (let j = 0; j < this.formData.menuId.length; j++) {
        for (let i = 0; i < this.initRouter.length; i++) {
          if (
            this.formData.menuId[j] === this.initRouter[i].id &&
            this.initRouter[i].permis.includes(':')
          ) {
            resources.push(this.initRouter[i].permis)
          }
        }
      }
      const allow = []
      allow.push({
        roles: this.formData.roleKey,
        allows: [
          {
            resources,
            permissions: '*'
          }
        ]
      })
      addRoleMenu({
        roleId,
        roleMenuArr,
        roleKey: this.formData.roleKey,
        allow
      })
        .then((res) => {
          this.getRoleinfo()
          this.$message.success('菜单权限添加成功')
        })
        .catch(() => {
          this.$message.warning('菜单权限添加失败')
        })
    },
    // 获取路由
    getRouterList(activeMenuList) {
      getRoleRouter().then((resData) => {
        this.initRouter = resData
        const newData = []
        for (let i = 0; i < resData.length; i++) {
          if (resData[i].menuType === 'M') {
            newData.push({
              id: resData[i].id,
              label: resData[i].menuName,
              children: []
            })
          }
          for (let j = 0; j < newData.length; j++) {
            if (
              resData[i].menuType === 'C' &&
              newData[j].id === resData[i].parentId
            ) {
              newData[j].children.push({
                label: resData[i].menuName,
                id: resData[i].id
              })
            }
          }
        }
        this.routerData = newData
        this.$nextTick(() => {
          activeMenuList.forEach((v) => {
            this.$refs.refMenu.setChecked(v.menuId, true, false)
          })
        })
      })
    },
    // 添加权限菜单
    handleCheckChange(checkedNodes, checkedKeys) {
      // 目前被选中的菜单节点
      const checkMenuIds = this.$refs.refMenu.getCheckedKeys()
      // 半选中的菜单节点
      const halfCheckedKeys = this.$refs.refMenu.getHalfCheckedKeys()
      checkMenuIds.unshift.apply(checkMenuIds, halfCheckedKeys)
      this.formData.menuId = checkMenuIds
      console.log('选中的节点数据：', checkMenuIds)
    }
  }
}
</script>
<style lang="scss">
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;

  .role_heard_tool {
    margin-bottom: 10px;
  }

  .edit_titile {
    .dialog_input {
      display: flex;
      align-items: center;
      // justify-content: space-around;
      width: 70%;

      .el-input {
        width: 70%;
      }
    }
  }

  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }

  .authority_info {
    margin-top: 25px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #ffffff;
    font-size: 26px;
    border: 1px solid #909399;
    border-radius: 25px;
    background: #c0c4cc;
    padding: 2px;
  }
}
</style>
